import {
	GET_ALL_BILL_DIRECT_PAYMENT_HEADER_REQUEST,
	GET_ALL_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
	GET_ALL_BILL_DIRECT_PAYMENT_HEADER_ERROR,  
	GET_ONE_BILL_DIRECT_PAYMENT_HEADER_REQUEST,
	GET_ONE_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
	GET_ONE_BILL_DIRECT_PAYMENT_HEADER_ERROR,  
	ADD_BILL_DIRECT_PAYMENT_HEADER_REQUEST,
	ADD_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
	ADD_BILL_DIRECT_PAYMENT_HEADER_ERROR,
	UPDATE_BILL_DIRECT_PAYMENT_HEADER_REQUEST,
	UPDATE_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
	UPDATE_BILL_DIRECT_PAYMENT_HEADER_ERROR, 
	DELETE_BILL_DIRECT_PAYMENT_HEADER_REQUEST,
	DELETE_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
	DELETE_BILL_DIRECT_PAYMENT_HEADER_ERROR,   
} from "../actions/types";

export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_ONE_BILL_DIRECT_PAYMENT_HEADER_REQUEST:
			return {
				loading: true,
			};
		case GET_ONE_BILL_DIRECT_PAYMENT_HEADER_SUCCESS:
			return {
				...state,
				loading: false,
				payload,
			};
		case GET_ONE_BILL_DIRECT_PAYMENT_HEADER_ERROR:
			return {
				...state,
				loading: false
			};
		case GET_ALL_BILL_DIRECT_PAYMENT_HEADER_REQUEST:
			return {
				loading: true,
			};
		case GET_ALL_BILL_DIRECT_PAYMENT_HEADER_SUCCESS:
			return {
				...state,
				loading: false,
				payload,
			};
		case GET_ALL_BILL_DIRECT_PAYMENT_HEADER_ERROR:
			return {
				...state,
				loading: false
			};
		case ADD_BILL_DIRECT_PAYMENT_HEADER_REQUEST:
			return {
				loading: true,
			};
		case ADD_BILL_DIRECT_PAYMENT_HEADER_SUCCESS:
			return {
				...state,
				loading: false,
				payload: [payload],
			};
		case ADD_BILL_DIRECT_PAYMENT_HEADER_ERROR:
			return {
				...state,
				loading: false
			};
		case DELETE_BILL_DIRECT_PAYMENT_HEADER_REQUEST:
			return {
				loading: true,
			};
		case DELETE_BILL_DIRECT_PAYMENT_HEADER_SUCCESS:
			return {
				...state,
				loading: false,
				payload: [payload],
			};
		case DELETE_BILL_DIRECT_PAYMENT_HEADER_ERROR:
			return {
				...state,
				loading: false
			};
		case UPDATE_BILL_DIRECT_PAYMENT_HEADER_REQUEST:
			return {
				loading: true,
			};
		case UPDATE_BILL_DIRECT_PAYMENT_HEADER_SUCCESS:
			return {
				...state,
				loading: false,
				payload: [payload],
			};
		case UPDATE_BILL_DIRECT_PAYMENT_HEADER_ERROR:
			return {
				...state,
				loading: false
			};
		default:
			return state;
	}
}
